
export const VIDEO_PROJECT_MAIN_VIDEO_DELETE = 'VIDEO_PROJECT_MAIN_VIDEO_DELETE';
export const VIDEO_PROJECT_MAIN_VIDEO_UPDATE = 'VIDEO_PROJECT_MAIN_VIDEO_UPDATE';
